"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCalculationPolicyVersionInputSchema = void 0;
const zod_1 = require("zod");
exports.createCalculationPolicyVersionInputSchema = zod_1.z.object({
    effectiveFrom: zod_1.z.string().min(1, "Unesite datum važenja."),
    notes: zod_1.z.string().trim().max(500).optional(),
});
//# sourceMappingURL=calculation-policy-settings.js.map